import { useGetShoppingCartQuery } from "@/store/shoppingCartApi";
import Link from "next/link";
import ShoppingCartSVG from "public/next-public/common/icons/cart.svg";
import style from "./standardPageHeader.module.scss";
export default function ShoppingCartSummaryV2() {
  const { data: shoppingCart } = useGetShoppingCartQuery();

  // Calculate total items in cart
  const totalItems = shoppingCart?.totalQuantity || 0;

  return (
    <Link id="cart" href="/shopping-cart" className={`${style.headerIconContainer} ${style.cart}`} prefetch={false}>
      <span className={style.headerIconWrapper}>
        <ShoppingCartSVG className={style.headerIcon} />
        {/* Cart Badge - Only show if there are items */}
        {totalItems > 0 && (
          <span
            className={style.cartBadge}
            data-over-999={totalItems > 999}
            data-three-digits={totalItems >= 100 && totalItems <= 999}
          >
            {totalItems > 999 ? "" : totalItems}
          </span>
        )}
      </span>

      {/* Cart Text */}
      <span className={style.headerIconText}>Cart</span>
    </Link>
  );
}
